import { useRef, useState } from "react";
import { AppPageHeader } from "@shared/ui/AppPageHeader";
import { ProgramPhase } from "@platform/types/platform.types";
import { ProgramPhasesTimelineContainer } from "../ProgramPhasesTimeline/ProgramPhasesTimelineContainer";
import { ProgramPhaseListContainer } from "../ProgramPhase/ProgramPhaseListContainer";
import { scrollToPhase } from "../../utils/scrollToPhase";

type Props = {
  currentPhase: ProgramPhase | undefined;
  phases: ProgramPhase[];
  isLoading: boolean;
};

export function ProgramPhases({ currentPhase, phases, isLoading }: Props) {
  const timelineRef = useRef<HTMLDivElement>(null);

  const phaseContainerRef = useRef<HTMLDivElement>(null);

  const [selectedPhase, setSelectedPhase] = useState<ProgramPhase | undefined>(
    undefined
  );

  const handlePhaseChange = (phase: ProgramPhase) => {
    setSelectedPhase(phase);

    scrollToPhase({
      index: phases.findIndex((p) => p.id === phase.id),
      phaseContainerRef: phaseContainerRef,
      timelineRef: timelineRef,
      scrollIntoView: true,
    });
  };

  const handlePhaseListReady = () => {
    if (currentPhase) {
      setTimeout(() => {
        requestAnimationFrame(() => {
          handlePhaseChange(currentPhase);
        });
      }, 100);
    }
  };

  return (
    <>
      <div className="flex flex-col gap-8 py-4 w-full">
        <AppPageHeader
          title="Program Phases"
          description="See what phase you're in now, and what's coming next."
        />

        <ProgramPhasesTimelineContainer
          timelineRef={timelineRef}
          selectedPhase={selectedPhase}
          setSelectedPhase={handlePhaseChange}
        />
      </div>

      <ProgramPhaseListContainer
        selectedPhase={selectedPhase}
        setSelectedPhase={handlePhaseChange}
        phaseContainerRef={phaseContainerRef}
        onPhaseListReady={handlePhaseListReady}
        isLoading={isLoading}
      />
    </>
  );
}

export default ProgramPhases;
